import createVueApp from '@phoenix/createVueApp';
import Countdown from '../components/organisms/Countdown.vue';

document.querySelectorAll('.phoenix-countdown').forEach((element) => {
  const app = createVueApp();
  app.component('Countdown', Countdown);
  app.mount(element);
});
